import React, { ReactNode } from 'react';

import styles from './AuthFormContainer.module.css';

type Props = {
  children: ReactNode,
}

const AuthFormContainer = ({ children }: Props) => (
  <div className={styles.container}>
    {children}
  </div>
);

export default AuthFormContainer;
